<template>
  <div class="vacancy-container">
    <div class="vacancy-header">
      <h1 class="vacancy-title">
        {{ content.title }}
      </h1>
      <div class="vacancy-addition-info">
        <span v-if="content.date">
          {{ date }}
        </span>
        <span @click="SendResumeLink" id="apply">{{ $t('listVacancy.ApplyForJob') }}</span>
        <input id="fileUpload" ref="resume-file-input" type="file" @change="ResumeLinkChange" accept=".doc, .pdf, .docx"
               hidden/>
      </div>
      <page-control :model="content"/>
      <div>
        <VueFileAgent
          :helpText="fileMessage"
          :multiple="true"
          ref="fileAgent"
          theme="list"
          class="vacancy-file-input"
          @beforedelete="onBeforeDelete"
          :maxSize="'5MB'"
          :deletable="true"
          :errorText="{
            type: 'Please select images, videos, pdf or zip files',
            size: 'Файл повинен бути менше ніж 5МБ'
          }"
          accept=".doc, .pdf, .docx"
          v-model="files"
        />
        <div class="d-flex align-center justify-space-around mt-3">
          <app-captcha
            ref="recaptcha"
            :isBudgeHidden="false"
            @verify="sendResume($event)"
          />
          <v-btn
            :loading="loading"
            tile
            class="submit-form-button"
            type="submit"
            elevation="0"
            color="#549EC7"
            @click="submit"
          >Відправити
          </v-btn
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import serviceDataAccess from '../../../services/service.data-access'
import AppCaptcha from '@/components/_shared/AppCaptcha.vue'

export default {
  components: {
    PageControl: () => import('../../app/PageControl'),
    AppCaptcha
  },
  name: 'VacancyDetails',
  props: ['model'],
  computed: {
    content: function () {
      return this.model
    },
    date: function () {
      var date = this.content.date
      return date.substring(0, date.length - 9)
    }
  },
  methods: {
    onBeforeDelete(fileRecord) {
      this.$refs.fileAgent.deleteFileRecord(fileRecord)
    },
    submit() {
      this.$refs.recaptcha.execute()
    },
    async sendResume(response) {
      var result = await this.PrepareFilesAndUpload(this.files, response)
      if (!result) {
        this.$uiService.success('Помилка відправки')
      } else {
        this.$uiService.success('Резюме відправлено успішно')
      }
    },
    SendResumeLink() {
      document.getElementById('fileUpload').click()
    },
    async ResumeLinkChange() {
      var files = this.$refs['resume-file-input'].files
      if (files.length !== 0) {
        var formData = new FormData()
        files.forEach((file) => {
          formData.append('files', new File([file], file.name))
        })
        await serviceDataAccess.sendResume(formData)
        this.$uiService.success('Резюме відправлено успішно')
      }
    },
    async PrepareFilesAndUpload(files, response) {
      if (files.length !== 0) {
        var formData = new FormData()
        formData.append('VacancyName', this.content.title)
        formData.append('googleReCaptchaResponse', response)
        files.forEach((file) => {
          formData.append('Files', new File([file.file], file.name()))
        })

        await serviceDataAccess.sendResume(formData)
        return true
      } else {
        return false
      }
    }
  },
  data: () => ({
    loading: false,
    files: [],
    fileMessage: 'Додати резюме'
  })
}
</script>
<style lang="scss" scoped>
.vacancy-container {
  max-width: 90rem !important;

  .vacancy-addition-info {
    font-size: 18px;
    color: #3A3A3A;
    margin-top: 10px;

    #apply {
      color: #4690BA;
      float: right;
    }

    #apply:hover {
      cursor: pointer;
    }
  }

  .vacancy-header {
    .vacancy-title {
      font-size: 3.8rem;
    }
  }

  .vacancy-file-input {
    display: block;
    margin-left: auto;
    margin-right: auto;
    max-width: 600px;
  }
}
</style>
